import React from 'react';

import {
  StatusSellersContainer,
  StatusTableContainer,
} from 'containers';

import styles from './styles.module.scss';

export const StatusPage = () => (
  <div className={styles.status_container}>
    <StatusSellersContainer />
    <StatusTableContainer />
  </div>
);
